import Configuration from "./configuration";

class PlatformUserService {
  constructor(token, user) {
    this.config = new Configuration(token, user, "api/PlatformUser");
  }

  /**
   * @method getAuthContext list all permissions user
   * @return {Promise} result object user permissions in platform
   */
  getAuthContext() {
    return this.config.API.get(`GetAuthContext`)
    .then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    })
    .catch(err => {
      console.error(err);
      return {};
    });
  }

  /**
   * @method getInvitations list all invitations user
   * @return {Promise} result object user invitations in platform
   */
  getInvitations() {
    return this.config.API.get(`GetInvitations`).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  /**
   * @method createInvitation send invitation for new user
   * @return {Promise} result object user invitations in platform
   */
  createInvitation(email, userRole) {
    return this.config.API.post(`CreateInvitation`, {
      email,
      userRole
    }).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  /**
   * @method updateInvitation send invitation for new user
   * @return {Promise} result object user invitations in platform
   */
  updateInvitation(invitationId) {
    return this.config.API.get(`UpdateInvitation`, {
      params: {
        invitationId
      }
    }).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  /**
   * @method cancelInvitation send invitation for new user
   * @return {Promise} result object user invitations in platform
   */
  cancelInvitation(invitationId) {
    return this.config.API.get(`CancelInvitation`, {
      params: {
        invitationId
      }
    }).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  /**
   * @method getPlatformUsers list all users
   * @return {Promise} result object user invitations in platform
   */
  getPlatformUsers() {
    return this.config.API.get(`GetPlatformUsers`).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  /**
   * @method modifyPlatformUser modify user platform name or phone
   * @return {Promise} result object user invitations in platform
   */
  modifyPlatformUser(user) {
    return this.config.API.post(`ModifyPlatformUser`, user).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  /**
   * @method inactivatePlatformUser list all users
   * @return {Promise} result object user invitations in platform
   */
  inactivatePlatformUser(platformUserId) {
    return this.config.API.get(`InactivatePlatformUser`, {
      params: { platformUserId }
    }).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  /**
   * @method activatePlatformUser list all users
   * @return {Promise} result object user invitations in platform
   */
  activatePlatformUser(platformUserId) {
    return this.config.API.get(`ActivatePlatformUser`, {
      params: { platformUserId }
    }).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  /**
   * @method dismissInvitation dismiss invitation
   * @return {Promise} result object user invitations in platform
   */
  dismissInvitation(invitationId) {
    return this.config.API.get(`DismissInvitation`, {
      params: { invitationId }
    }).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  /**
   * @method createPlatformUser created new user platform
   * @return {Promise} result object user invitations in platform
   */
  createPlatformUser(id, userName, mobile) {
    return this.config.API.post(
      `CreatePlatformUser`,
      {},
      {
        params: { id, mobile, userName }
      }
    ).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }
}

export default PlatformUserService;
